import { PowderFinish } from "./powderFinish";

export interface IPowderFinish {
	text: string;
	value: PowderFinish;
}

const values: IPowderFinish[] = [
	{
		text: "Matt",
		value: PowderFinish.Matt,
	},
	{
		text: "Glänzend",
		value: PowderFinish.Glossy,
	},
];

export default values;
